import "./TradingSteps.css";
import React from "react";

const TradingSteps = () => {
  return (
    <section className="list-items">
      <div className="divcontainer3">
        <div className="security-group">
          <div className="trading-steps-parent">
            <h1 className="trading-steps">Trading Steps</h1>
            <div className="how-to-trade">How to Trade with Forex Miner</div>
          </div>
        </div>

        <div className="image-4-parent">
          <div className="muhammad-abdullah-icon">
            <div className="link-whitepaper-wrapper">
              <div className="link-whitepaper">
                <div className="list-links">
                  <div className="divroadmap-list-inner">
                    <div className="symbol-item-link">
                      <div className="step-1-subscribe-container">
                        <p className="step-1">Step 1</p>
                        <p className="subscribe-to-plan">Subscribe to Plan</p>
                      </div>
                    </div>
                    <div className="list1">
                      <div className="item4">
                        <div className="before3" />
                        <div className="navigate-to-subscription">
                          Navigate to Subscription Section
                        </div>
                      </div>
                      <div className="item5">
                        <div className="before4" />
                        <div className="choose-the-plan">Choose the plan</div>
                      </div>
                      <div className="item6">
                        <div className="before5" />
                        <div className="complete-the-subscription">
                          Complete the subscription process
                        </div>
                      </div>
                      <div className="item7">
                        <div className="before6" />
                        <div className="receive-a-confirmation">
                          Receive a confirmation email
                        </div>
                      </div>
                      <div className="divicon1">
                        <img
                          className="rm-iconpng"
                          loading="lazy"
                          alt=""
                          src="/rm-iconpng@2x.png"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="list-links3">
                  <div className="divroadmap-list-inner">
                    <div className="symbol-item-link">
                      <div className="step-1-subscribe-container">
                        <p className="step-1">Step 2</p>
                        <p className="subscribe-to-plan">Get Bot Access</p>
                      </div>
                    </div>
                    <div className="list1">
                      <div className="item4">
                        <div className="before3" />
                        <div className="navigate-to-subscription">
                          Get bot link
                        </div>
                      </div>
                      <div className="item5">
                        <div className="before4" />
                        <div className="choose-the-plan">
                          Find the download section
                        </div>
                      </div>
                      <div className="item6">
                        <div className="before5" />
                        <div className="complete-the-subscription">
                          Choose appropriate version
                        </div>
                      </div>
                      <div className="item7">
                        <div className="before6" />
                        <div className="receive-a-confirmation">
                          Download the platform
                        </div>
                      </div>
                      <div className="divicon1">
                        <img
                          className="rm-iconpng"
                          loading="lazy"
                          alt=""
                          src="/rm-iconpng@2x.png"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="security-measures-container">
                  <div className="security-measures-frame">
                    <div className="security-measures-frame1">
                      <img
                        className="graident-ai-robot-1"
                        loading="lazy"
                        alt=""
                        src="/Bot_Image.png"
                      />
                    </div>
                    <div className="contact-information-frame">
                      <div className="divroadmap-list-inner1">
                        <div className="contact-us-frame">
                          <div className="step-3-connect-container">
                            <p className="step-3">Step 3</p>
                            <p className="connect-trading-account">
                              Connect Trading Account
                            </p>
                          </div>
                        </div>
                        <div className="list2">
                          <div className="item8">
                            <div className="before8" />
                            <div className="launch-the-trading">
                              Launch the trading platform
                            </div>
                          </div>
                          <div className="item9">
                            <div className="before9" />
                            <div className="look-for-connect">
                              Look for Connect Account option
                            </div>
                          </div>
                          <div className="item10">
                            <div className="before10" />
                            <div className="enter-login-credentials">{`Enter login credentials `}</div>
                          </div>
                          <div className="item11">
                            <div className="before11" />
                            <div className="connect-your-account">
                              Connect your account
                            </div>
                          </div>
                        </div>
                        <button className="divicon2">
                          <img
                            className="rm-iconpng1"
                            alt=""
                            src="/rm-iconpng-1@2x.png"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-widget-list">
              <img className="before-icon" alt="" src="/__before.svg" />
            </div>
            <div className="footer-widget-list1">
              <div className="footer-widget-list2">
                <div className="itemprivacypolicy">
                  <img
                    className="data-charts-on-stage-screen-1-icon"
                    loading="lazy"
                    alt=""
                    // src="/Bot-Gif.gif"
                    src="/coins-1@2x.png"
                  />
                </div>
                <div className="divroadmap-list-inner2">
                  <div className="footer-widget-list3">
                    <div className="step-2-get-container">
                      <p className="step-2">Step 2</p>
                      <p className="get-bot-access">Get Bot Access</p>
                    </div>
                  </div>
                  <div className="divicon3">
                    <img
                      className="rm-iconpng2"
                      alt=""
                      src="/rm-iconpng-2@2x.png"
                    />
                  </div>
                  <div className="frame-muhammad-abdullah">
                    <div className="list3">
                      <div className="item12">
                        <div className="before14" />
                        <div className="get-bot-link">Get bot link</div>
                      </div>
                      <div className="item13">
                        <div className="before15" />
                        <div className="find-the-download">
                          Find the download section
                        </div>
                      </div>
                      <div className="item14">
                        <div className="before16" />
                        <div className="choose-appropriate-version">
                          Choose appropriate version
                        </div>
                      </div>
                      <div className="item15">
                        <div className="before17" />
                        <div className="download-the-platform">
                          Download the platform
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="itemprivacypolicy">
                  <img
                    className="data-charts-on-stage-screen-1-icon"
                    loading="lazy"
                    alt=""
                    src="/datachartsonstagescreen-1@2x.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TradingSteps;
